import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { LoginComponent } from "./components/login/login.component";
import { FormsModule } from "@angular/forms";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { SharedModule } from "../shared/shared.module";
import { ConfirmPasswordComponent } from "@app/modules/authentication/components/confirm-password/confirm-password.component";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { NewPasswordComponent } from "./components/new-password/new-password.component";
import { KalemHttpInterceptor } from "@app/modules/shared/services/kalem.interceptor";

@NgModule({
  declarations: [
    LoginComponent,
    ConfirmPasswordComponent,
    ResetPasswordComponent,
    NewPasswordComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: "",
        redirectTo: "login",
        pathMatch: "full",
      },
      {
        path: "login",
        component: LoginComponent,
      },
      {
        path: "confirm-password",
        component: ConfirmPasswordComponent,
      },
      {
        path: "reset-password",
        component: ResetPasswordComponent,
      },
      {
        path: "new-password",
        component: NewPasswordComponent,
      },
    ]),
    FormsModule,
    HttpClientModule,
    SharedModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KalemHttpInterceptor,
      multi: true,
    },
  ],
  entryComponents: [
    LoginComponent,
    ConfirmPasswordComponent,
    ResetPasswordComponent,
    NewPasswordComponent,
  ],
  exports: [RouterModule],
})
export class AuthenticationModule {}
